
import { Input, Form } from 'antd';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    editType,
    editRules = [],
    record,
    index,
    children,
    ...restProps
}) => {
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={editRules}
                >
                    {(editType == null ? <Input /> : editType)}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

export default EditableCell;